import { NgModule } from '@angular/core';
import { AnimationLoader } from '../animation-loader';
import { CacheableAnimationLoader } from './cacheable-animation-loader';
import * as ɵngcc0 from '@angular/core';
export class LottieCacheModule {
    static forRoot() {
        return {
            ngModule: LottieCacheModule,
            providers: [
                {
                    provide: AnimationLoader,
                    useClass: CacheableAnimationLoader,
                },
            ],
        };
    }
}
LottieCacheModule.ɵfac = function LottieCacheModule_Factory(t) { return new (t || LottieCacheModule)(); };
LottieCacheModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LottieCacheModule });
LottieCacheModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LottieCacheModule, [{
        type: NgModule
    }], null, null); })();

